/**
 * @generated SignedSource<<6c4ed18342bb4fc503a0aa1f69ebc754>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CloneContentModuleFormFieldsFragment$data = {
  readonly id: string;
  readonly products: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly collectionApps: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly collection: {
                readonly id: string;
              } | null;
              readonly customAppTitle: string | null;
              readonly id: string;
              readonly " $fragmentSpreads": FragmentRefs<"CollectionDropdownItemFragment">;
            };
          }>;
        };
        readonly curriculum: {
          readonly id: string;
        } | null;
        readonly curriculumApps: {
          readonly totalCount: number;
        };
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly startDate: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"ProductDropdownItemFragment">;
      };
    }>;
  };
  readonly " $fragmentType": "CloneContentModuleFormFieldsFragment";
};
export type CloneContentModuleFormFieldsFragment$key = {
  readonly " $data"?: CloneContentModuleFormFieldsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CloneContentModuleFormFieldsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CloneContentModuleFormFieldsFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filterByAdminAccess",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "type",
          "value": "course"
        }
      ],
      "concreteType": "ProductNodeConnection",
      "kind": "LinkedField",
      "name": "products",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startDate",
                  "storageKey": null
                },
                {
                  "alias": "curriculumApps",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "kind",
                      "value": "curriculum"
                    }
                  ],
                  "concreteType": "ProductAppNodeConnection",
                  "kind": "LinkedField",
                  "name": "productApps",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalCount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": "productApps(kind:\"curriculum\")"
                },
                {
                  "alias": "collectionApps",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "kind",
                      "value": "collection"
                    }
                  ],
                  "concreteType": "ProductAppNodeConnection",
                  "kind": "LinkedField",
                  "name": "productApps",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductAppNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductApp",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "customAppTitle",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Collection",
                              "kind": "LinkedField",
                              "name": "collection",
                              "plural": false,
                              "selections": (v1/*: any*/),
                              "storageKey": null
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "CollectionDropdownItemFragment"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "productApps(kind:\"collection\")"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Curriculum",
                  "kind": "LinkedField",
                  "name": "curriculum",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProductDropdownItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "products(filterByAdminAccess:true,type:\"course\")"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "ca40f2aab45c958c2b7193ccb26cc1d9";

export default node;
